import logo from './logo.svg';
import './App.css';
import firebase from "./Firebase"
import { BrowserRouter as Router, Routes, Route  } from 'react-router-dom';
import Login from './Login';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import Users from './Users';
import Profile from './Profile';
import Products from './Products';
import Register from './Register';
import Category from './Category';
import Foot from './Foot';
import Dashboard from './Dashboard';
import Billing from './Billing';
import Orders from './Orders';
import { Navigate } from "react-router-dom";
import Logingoogle from './Logingoogle';
import Contact from './Contact';
import About from './About';
import Confirmorders from './Confirmorders';
import Feedback from './Feedback';
import FeedbackUser from './FeedbackUser';


function App() {
  
  return(

<Router>
  <Routes>
  <Route path='/' element={<Dashboard/>} />
        <Route path='/Users' element={<Users/>} />
        <Route path='/Profile' element={<Profile/>} />
        <Route path='/Products' element={<Products/>} />
        <Route path='/Register' element={<Register/>} />
        <Route path='/Category' element={<Category/>} />
        <Route path='/Login' element={<Login/>} />
        <Route path='/Billing' element={<Billing/>} />
        <Route path='/Orders' element={<Orders/>} />
        <Route path='/Logingoogle' element={<Logingoogle/>} />
        <Route path='/Foot' element={<Foot/>} />
        <Route path='/Contact' element={<Contact/>} />
        <Route path='/About' element={<About/>} />
        <Route path='/Confirmorders' element={<Confirmorders/>} />
   <Route path='/Feedback' element={<Feedback/>} />
      <Route path='/FeedbackUser' element={<FeedbackUser/>} />
  </Routes>
</Router>

    
  // <Login/>
)
}



export default App;